const AUTH_RETURN_TO_KEY = "authReturnTo";

/**
 * 現在のURLパスを sessionStorage に保存する。
 * フィードバック画面からサインアップ/ログインする際に呼び出す。
 */
export function saveAuthReturnTo(): void {
  try {
    sessionStorage.setItem(AUTH_RETURN_TO_KEY, window.location.pathname);
  } catch {
    // プライベートブラウジング等で SecurityError が発生する場合は無視する
  }
}

/**
 * アプリ内のパスかどうかを判定する。
 * オープンリダイレクト防止のため、`/` で始まり `//` でないことを求める。
 */
function isInternalPath(value: string | null): value is string {
  return !!value && value.startsWith("/") && !value.startsWith("//");
}

/**
 * sessionStorage から authReturnTo を読み取り、バリデーションして返す。
 * オープンリダイレクト防止のため、`/` で始まり `//` でないことを検証する。
 */
export function getAuthReturnTo(): string | null {
  try {
    const value = sessionStorage.getItem(AUTH_RETURN_TO_KEY);
    return isInternalPath(value) ? value : null;
  } catch {
    return null;
  }
}

/**
 * 現在のURLの `next` パラメータを authReturnTo として保存する。
 * 大学からの招待メールのように、外部から復帰先を指定して認証画面へ来る導線で使う。
 * 保存できた場合のみ true を返す。検証を通らない値は無視する。
 */
export function saveAuthReturnToFromQuery(): boolean {
  try {
    const next = new URLSearchParams(window.location.search).get("next");
    if (!isInternalPath(next)) return false;

    sessionStorage.setItem(AUTH_RETURN_TO_KEY, next);
    return true;
  } catch {
    // プライベートブラウジング等で SecurityError が発生する場合は無視する
    return false;
  }
}

/**
 * sessionStorage から authReturnTo を削除する。
 * claim + リダイレクト完了後に呼び出し、再利用を防止する。
 */
export function clearAuthReturnTo(): void {
  try {
    sessionStorage.removeItem(AUTH_RETURN_TO_KEY);
  } catch {
    // ignore
  }
}
